import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { CheckboxField } from '../../../forms/fields/checkbox/checkbox-field.component';
import { ChecklistField } from '../../../forms/fields/checklist/checklist-field.component';
import { DateField } from '../../../forms/fields/date-field/date-field.component';
import { DatePickerField } from '../../../forms/fields/date-picker/date-picker-field.component';
import { DateRangeField } from '../../../forms/fields/date-range/date-range-field.component';
import { DropdownField } from '../../../forms/fields/dropdown/dropdown-field.component';
import { EmailField } from '../../../forms/fields/email-field/email-field.component';
import { MoneyField } from '../../../forms/fields/money-field/money-field.component';
import { MultiselectField } from '../../../forms/fields/multiselect/multiselect-field';
import { NumberField } from '../../../forms/fields/number-field/number-field.component';
import { OptionSwitchField } from '../../../forms/fields/option-switch/option-switch-field.component';
import { PhoneField } from '../../../forms/fields/phone-field/phone-field.component';
import { PostalCodeField } from '../../../forms/fields/postal-code-field/postal-code-field.component';
import { RadioField } from '../../../forms/fields/radio/radio-field.component';
import { SearchField } from '../../../forms/fields/search-field/search-field.component';
import { SsnField } from '../../../forms/fields/ssn-field/ssn-field.component';
import { SwitchField } from '../../../forms/fields/switch/switch-field.component';
import { TimeField } from '../../../forms/fields/time-field/time-field';
import { TimeRangeField } from '../../../forms/fields/time-range-field/time-range-field';
import { SelectListField } from '../../../forms/list-fields/select-list/select-list-field';

const filterMapSectionStyle1 = css`
  margin-bottom: ${theme.spacing(2)};
`;

export const fieldComponentsMap = {
  checkbox: CheckboxField,
  multiselect: MultiselectField,
  checklist: ChecklistField,
  selectlist: SelectListField,
  optionswitch: OptionSwitchField,
  dropdown: DropdownField,
  switch: SwitchField,
  text: SearchField,
  radio: RadioField,
  datePicker: DatePickerField,
  dateRange: DateRangeField,
  date: DateField,
  email: EmailField,
  money: MoneyField,
  phone: PhoneField,
  ssn: SsnField,
  postalCode: PostalCodeField,
  time: TimeField,
  timeRange: TimeRangeField,
  number: NumberField,
};

const fieldHasOptions = {
  multiselect: true,
  checklist: true,
  optionswitch: true,
  dropdown: true,
  selectlist: true,
  radio: true,
};

const extraProps = {
  radio: { labelPlacement: 'left', label: undefined },
  checklist: { labelPlacement: 'left', label: undefined },
  optionswitch: { label: undefined },
};

export const FieldFilterWithOptions = ({ type, fieldProps, label, options }) => {
  const Component = fieldComponentsMap[type];
  return (
    <Component {...fieldProps} label={label} {...extraProps[type]}>
      {options.map((data, idx) => {
        switch (type) {
          case 'radio':
            return (
              <Component.Radio key={`${data}-${idx}`} value={data}>
                {data}
              </Component.Radio>
            );
          case 'checklist':
            return (
              <Component.Option key={`${data}-${idx}`} name={data}>
                {data}
              </Component.Option>
            );

          default:
            return (
              <Component.Option key={data} value={data}>
                {data}
              </Component.Option>
            );
        }
      })}
    </Component>
  );
};

export const FilterMapComponent = ({ type, fieldProps, label, options }) => {
  const hasOptions = !!fieldHasOptions[type];
  const Component = fieldComponentsMap[type];

  return hasOptions ? (
    <section className={filterMapSectionStyle1}>
      <FieldFilterWithOptions type={type} fieldProps={fieldProps} label={label} options={options} />
    </section>
  ) : (
    <section className={filterMapSectionStyle1}>
      <Component {...fieldProps} label={label} />{' '}
    </section>
  );
};
